<template>
  <main role="main" class="about-page mt-[3.9rem] md:mt-14">

    <!-- Hero Banner -->
    <div class="about-hero">
      <div class="container">
        <img :src="require('@/assets/home_lg.png')" alt="" aria-hidden="true" class="about-hero__img" />
      </div>
    </div>

    <!-- About Content -->
    <section class="about-section">
      <div class="container">

        <div class="about-content">
          <h1 class="about-title">{{ t('about.title') }}</h1>
          <div class="about-body">
            <p v-html="t('about.para1')"></p>
            <p>{{ t('about.para2') }}</p>
            <p>{{ t('about.para3') }}</p>
          </div>
        </div>

        <div class="about-links">
          <a
            href="https://www.linkedin.com/in/saul-verde-martinez/"
            target="_blank"
            rel="noopener noreferrer"
            class="about-btn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" class="about-btn__icon" aria-hidden="true">
              <path fill="currentColor" d="M116 3H12a8.91 8.91 0 00-9 8.8v104.42a8.91 8.91 0 009 8.78h104a8.93 8.93 0 009-8.81V11.77A8.93 8.93 0 00116 3zM39.17 107H21.06V48.73h18.11zm-9-66.21a10.5 10.5 0 1110.49-10.5 10.5 10.5 0 01-10.54 10.48zM107 107H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53V48.73h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75z"/>
            </svg>
            <span>LinkedIn</span>
          </a>

          <a
            href="https://github.com/Greenvahn"
            target="_blank"
            rel="noopener noreferrer"
            class="about-btn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" class="about-btn__icon" aria-hidden="true">
              <g fill="currentColor">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"/>
                <path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"/>
              </g>
            </svg>
            <span>Github</span>
          </a>

          <div class="about-cert">
            <img
              src="https://images.credly.com/size/340x340/images/00634f82-b07f-4bbd-a6bb-53de397fc3a6/image.png"
              alt="AWS Certified Cloud Practitioner badge"
              class="about-cert__badge"
            />
            <a
              href="https://www.credly.com/badges/acacb9fc-efd2-4121-8bb2-75e9e59bef67?source=linked_in_profile"
              target="_blank"
              class="underline dark:text-white dark:decoration-white"
            >
              AWS Certified Cloud Practitioner
            </a>
          </div>
        </div>

      </div>
    </section>

  </main>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "About-me",
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<style scoped>

.about-page {
  background-color: var(--surface-bg);
}

/* Hero banner */
.about-hero {
  padding-top: var(--space-12);
}

.about-hero__img {
  width: 100%;
  display: block;
  object-fit: cover;
  border-radius: var(--radius-lg);
}

/* Section wrapper */
.about-section {
  padding: var(--space-8) 0;
}

.container {
  width: 100%;
  max-width: var(--grid-max-width);
  margin: 0 auto;
  padding: 0 var(--grid-padding);
}

/* Text content */
.about-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  margin-bottom: var(--space-12);
}

.about-title {
  font-family: var(--font-display);
  font-size: var(--text-5xl);
  font-weight: var(--weight-bold);
  line-height: var(--leading-tight);
  letter-spacing: var(--tracking-snug);
  color: var(--text-primary);
  margin: 0;
}

.about-body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  font-family: system-ui, -apple-system, sans-serif;
  font-size: var(--text-base);
  line-height: var(--leading-relaxed);
  color: var(--text-secondary);
}

.about-body p {
  margin: 0;
}

/* "Amazon" link styled via v-html — bold + underline */
.about-body :deep(a) {
  color: inherit;
  text-decoration: underline;
}

.about-body :deep(a strong) {
  font-weight: var(--weight-bold);
}

/* Links row */
.about-links {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-wrap: wrap;
  margin-bottom: var(--space-8);
}

.about-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 40px;
  padding: 0 var(--space-5);
  border: 1.5px solid var(--border-default);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--text-tertiary);
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  text-decoration: none;
  white-space: nowrap;
  transition: border-color var(--duration-fast) var(--ease-default),
              color var(--duration-fast) var(--ease-default);
}

.about-btn:hover {
  border-color: var(--border-strong);
  color: var(--text-secondary);
}

.about-btn__icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* AWS cert */
.about-cert {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-left: var(--space-6);
  max-width: 200px;
}

.about-cert a {
  color: var(--text-secondary);
  transition: color var(--duration-fast) var(--ease-default);
}

.about-cert:hover a {
  color: var(--text-primary);
}

.about-cert__badge {
  width: 49px;
  height: 49px;
  flex-shrink: 0;
  object-fit: cover;
}

.about-cert__label {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
  color: var(--color-neutral-700);
  text-decoration: underline;
  max-width: 130px;
  transition: color var(--duration-fast) var(--ease-default);
}

.about-cert__label:hover {
  color: var(--color-neutral-900);
}

/* Responsive */
@media (max-width: 768px) {

  .about-title {
    font-size: var(--text-3xl);
  }

  .about-cert {
    margin-left: 0;
    margin-top: var(--space-2);
  }

  .about-section {
    padding: var(--space-6) 0;
  }

  .about-hero {
    padding-top: var(--space-4);
  }

  .about-hero__img {
    height: 145px;
    object-position: 10% center;
  }
}

</style>
